// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueAnimateNumber from 'vue-animate-number'
import VeeValidate from 'vee-validate'
import Multiselect from 'vue-multiselect'

// COMPONENTS //
import PerformanceBoxComponent from '@/components/tools/PerformanceBoxComponent.vue'
import OrderTableComponent from '@/components/tools/Tables/OrderTableComponent'
import ClickCollectTableComponent from '@/components/tools/Tables/ClickCollectTableComponent'
import ProductsTable from '@/components/tools/Tables/ProductsTable'
import PaginationComponent from '@/components/tools/PaginationComponent'
import InvoicesTableComponent from '@/components/tools/Tables/InvoicesTable'
import SapInvoicesTableComponent from '@/components/tools/Tables/SapInvoicesTable'
import ReservationsTable from '@/components/tools/Tables/ReservationsTable'
import ShipcloudTable from '@/components/tools/Tables/ShipcloudTable'
import CancelModal from '@/components/tools/Modals/CancelModal'
import ReturnModal from '@/components/tools/Modals/ReturnModal'
import AmazonFeesModal from './components/tools/Modals/AmazonFeesModal'
import SupportModal from '@/components/tools/Modals/SupportModal'
import EditAddressModal from '@/components/tools/Modals/EditAddressModal'
import RefundModal from '@/components/tools/Modals/RefundModal'
import RankingModal from '@/components/tools/Modals/RankingModal'
import PriceInfoModal from '@/components/tools/Modals/PriceInfoModal'
import BulkUpdateModal from '@/components/tools/Modals/BulkUpdateModal'
import FileUpload from '@/components/tools/FileUpload'
import NewsComponent from '@/components/tools/NewsComponent'
import RedReturns from '@/components/tools/RedReturns'
import AmazonTokenRenewalReminder from '@/components/tools/AmazonTokenRenewalReminder'
import BarChart from '@/components/tools/Charts/BarChart'
import LineChart from '@/components/tools/Charts/LineChart'
import SalesReportChart from '@/components/tools/Charts/SalesReportChart'
import MultipleLineChart from '@/components/tools/Charts/MultipleLineChart'
import ChartPagination from '@/components/tools/ChartPaginationComponent'
import SalesReport from '@/components/tools/SalesReport'
import StatsReport from '@/components/tools/StatisticsReport'
import StatsDescription from '@/components/tools/StatsDescriptionBox'
import PriceBox from '@/components/tools/PriceBoxComponent'
import ConnectedRetail from '@/components/tools/ConnectedRetailComponent'
import OrderNote from '@/components/tools/OrderNotes'
import PriceBoxMPComponent from '@/components/tools/PriceBoxMPComponent'
import AddDeviceModal from '@/components/tools/Modals/AddDeviceModal'
import ProductChannel from '@/components/tools/TableRows/ProductChannelsRow'
import LabelRow from '@/components/tools/TableRows/LabelRow'
import TamarisReport from '@/components/tools/TamarisReport'
import MPDirectBox from '@/components/tools/MarketplaceDirectSaleBox'
import HistoryImportInfoModal from '@/components/tools/Modals/HistoryImportInfoModal'
import TamarisATReport from '@/components/tools/TamarisATReport'
import ShippingConfigModal from './components/tools/Modals/ShippingConfigModal.vue'
import ResultPerSideBar from "./components/tools/ResultPerSideBar";

// FILTERS //
import { domain, toLower, count, fieldNotInUse, newCountry, prettyDate, pluralize, orderDateReverse, capitalize, currency, translate, dateFormat2, dateFormat, toUpper, orderDate, orderTitle, country, percentage } from './filters'

Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('fieldNotInUse', fieldNotInUse)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('capitalize', capitalize)
Vue.filter('currency', currency)
Vue.filter('translate', translate)
Vue.filter('dateFormat', dateFormat)
Vue.filter('dateFormat2', dateFormat2)
Vue.filter('toUpper', toUpper)
Vue.filter('orderDate', orderDate)
Vue.filter('orderTitle', orderTitle)
Vue.filter('country', country)
Vue.filter('orderDateReverse', orderDateReverse)
Vue.filter('percentage', percentage)
Vue.filter('toLower', toLower)
Vue.filter('newCountry', newCountry)
Vue.component('tamarisReport', TamarisReport)
Vue.component('tamarisATReport', TamarisATReport)
Vue.component('myPagination', PaginationComponent)
Vue.component('chartPagination', ChartPagination)
Vue.component('invoicesTable', InvoicesTableComponent)
Vue.component('sapInvoicesTable', SapInvoicesTableComponent)
Vue.component('orderTable', OrderTableComponent)
Vue.component('productsTable', ProductsTable)
Vue.component('cancelModal', CancelModal)
Vue.component('returnModal', ReturnModal)
Vue.component('rankingModal', RankingModal)
Vue.component('priceInfoModal', PriceInfoModal)
Vue.component('bulkUpdateModal', BulkUpdateModal)
Vue.component('supportModal', SupportModal)
Vue.component('editModal', EditAddressModal)
Vue.component('refundModal', RefundModal)
Vue.component('fileUpload', FileUpload)
Vue.component('news', NewsComponent)
Vue.component('redReturns', RedReturns)
Vue.component('amazonTokenRenewalReminder', AmazonTokenRenewalReminder)
Vue.component('barChart', BarChart)
Vue.component('lineChart', LineChart)
Vue.component('amazonFeesModal', AmazonFeesModal)
Vue.component('historyImportInfo', HistoryImportInfoModal)
Vue.component('salesReportChart', SalesReportChart)
Vue.component('MultiLineChart', MultipleLineChart)
Vue.component('salesReport', SalesReport)
Vue.component('statsReport', StatsReport)
Vue.component('statsDescription', StatsDescription)
Vue.component('performanceBox', PerformanceBoxComponent)
Vue.component('Multiselect', Multiselect)
Vue.component('clickCollectTable', ClickCollectTableComponent)
Vue.component('reservationsTable', ReservationsTable)
Vue.component('shipcloudTable', ShipcloudTable)
Vue.component('priceBox', PriceBox)
Vue.component('connectedRetail', ConnectedRetail)
Vue.component('priceBoxMp', PriceBoxMPComponent)
Vue.component('orderNotes', OrderNote)
Vue.component('productChannel', ProductChannel)
Vue.component('labelRow', LabelRow)
Vue.component('addDeviceModal', AddDeviceModal)
Vue.component('MpBox', MPDirectBox)
Vue.component('ResultPerSideBar', ResultPerSideBar)
Vue.component('ShippingConfigModal', ShippingConfigModal)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(VueAnimateNumber)
Vue.use(VeeValidate, {fieldsBagName: 'veeFields'})

/* eslint-disable no-new */
API.defaults.baseURL = getURI()
API.defaults.headers.common['Content-Type'] = 'application/json'
API.interceptors.request.use(config => {
  let parsedUrl = config.url.split('?')[1]
  if (typeof parsedUrl !== 'undefined') {
    let splitParams = parsedUrl.split('&')
    for (let u in splitParams) {
      let splitted = splitParams[u].split('=')
      let encoded = encodeURIComponent(splitted[1])
      splitParams[u] = [splitted[0], encoded].join('=')
    }
    config.url = `${config.url.split('?')[0]}?${splitParams.join('&')}`
  }
  if (config.url.match('/accounting/user/password-re')) {
    return config
  }
  if (config.url.match(/login.*/)) {
    config.headers.common['order-token'] = store.getters.orderToken
    return config
  }
  if (store.getters.loggedInStatus) {
    config.headers.common['auth-token'] = store.getters.token
    return config
  }
  router.push('/')
}, error => {
  console.log(error)
})
API.interceptors.response.use(response => {
  return response
}, (error) => {
  if (error.response && error.response.status === 401) {
    if (error.config.url.match(/password-reset.*/)) {
      return Promise.reject(error)
    } else {
      store.commit('updateLoggedInStatus', false)
      store.dispatch('logout')
    }
  }
  return Promise.reject(error)
})
router.beforeEach((to, from, next) => {
  store.commit('initialiseStore')
  if (to.path === '/confirm' || to.path === '/password-reset') {
    window.localStorage.setItem('confirmUser', to.query.activation_username)
    window.localStorage.setItem('confirmToken', to.query.activation_token)
  }
  if (to.path === '/home' && to.query.auth_token) {
    store.dispatch('csLogin', to.query.auth_token)
    next()
  }
  if (to.meta.auth && !store.getters.loggedInStatus) {
    next({
      path: '/'
    })
  }
  if (to.path === '/' && store.getters.loggedInStatus) {
    next({
      path: '/home'
    })
  }
  if (to.path === '/orderDetail') {
    if (to.query.order && to.query.orderToken) {
      store.commit('updateOrderWithTokenId', to.query.order)
      store.commit('updateOrderToken', to.query.orderToken)
      store.dispatch('orderLogin')
      if (store.getters.user.username === '') {
        store.commit('updateUser', {
          username: 'OrderHandler',
          first_name: 'Order',
          last_name: 'Handler',
          email: 'order.handler@handler.com',
          company: 'OrderHandler'
        })
      }
    }
  }
  next()
})
store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem('store', JSON.stringify(state))
})
new Vue({
  el: '#app',
  router,
  store,
  beforeCreate () {
    this.$store.commit('initialiseStore')
  },
  components: { App },
  template: '<App/>'
})

function getURI () {
  let productionURLs = ['myplace.qb-schuhe.de', 'qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de']
  if ((productionURLs.indexOf(window.location.hostname)) !== -1) {
    // return 'https://myplace-backend.qb-schuhe.de/v1'
    return 'https://myplace-lambda.qb-schuhe.de/v1'
  } else if (window.location.hostname === 'localhost' || window.location.hostname === 'qualibet.local' || window.location.hostname === 'myplace-frontend.test') {
    return 'http://myplace-backend.test/v1'
  } else if (window.location.hostname === 'myplace.staging-qb.de') {
    return 'https://7tx0hhkfva.execute-api.eu-central-1.amazonaws.com/cloud/v1'
  }
}



// WEBPACK FOOTER //
// ./src/main.js